<template>
  <OwnPopover
    class="support-button"
    align-y="bottom"
    align-x="center"
    trigger-type="hover"
    content-offset="8"
    :content-width="contentWidth"
  >
    <template #trigger="{ on }">
      <button class="support-button__trigger" v-on="on" @click="handleClick">
        <component :is="icon" :size="iconSize" />
      </button>
    </template>
    <template #content>
      <OwnCard class="support-button__content" control>
        <OwnType :text="label" variant="paragraph-small" color="secondary" />
      </OwnCard>
    </template>
  </OwnPopover>
</template>

<script lang="ts" setup>
import { PhChatTeardropText } from '@phosphor-icons/vue'
import { computed, type Component } from 'vue'

import { OwnCard } from '@/ui/OwnCard'
import { OwnPopover } from '@/ui/OwnPopover'
import { OwnType } from '@/ui/OwnType'

const props = withDefaults(
  defineProps<{
    contentWidth?: number | string
    icon?: Component
    label?: string
    size?: 'small' | 'medium' | 'large'
  }>(),
  {
    contentWidth: 'fit-content',
    icon: PhChatTeardropText,
    label: 'Need help?',
    size: 'medium',
  }
)

const emit = defineEmits<{
  support: []
}>()

const iconSize = computed(() => {
  switch (props.size) {
    case 'small':
      return 16
    case 'large':
      return 32
    default:
      return 24
  }
})

const handleClick = () => {
  emit('support')
}
</script>

<style lang="scss" scoped>
@use '@/styles/globals';

.support-button {
  &__trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: var(--text-color-secondary);
    transition: globals.transitionOne(color);

    &:hover {
      color: var(--text-color-primary);
    }
  }

  &__content {
    padding: 8px 12px;
  }
}
</style>
